<table border="1" cellpadding="8" style="width: 100%; border-collapse: collapse;">
  <tr style="text-align: center;">
    <th style="padding: 5px; border: 1px solid #000000;">#</th>
    <th style="padding: 5px; border: 1px solid #000000;">Account</th>
    <th style="padding: 5px; border: 1px solid #000000;">Account Name</th>
    <th style="padding: 5px; border: 1px solid #000000;">Amount</th>
  </tr>
  @if (items?.length) {
  @for (item of items; track item; let index = $index) {
  <tr style="border: 1px solid #000000">
    <td style="text-align: center; border: 1px solid #000000;">{{ index + 1 }}</td>
    <td style="text-align: center; border: 1px solid #000000;">{{ item.accountCode }}</td>
    <td style="line-height: 16px; border: 1px solid #000000;">{{ item.accountName }}</td>
    <td style="font-weight: 500; font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.amount | price }}</td>
  </tr>
  }
  }
  @else {
  <tr>
    <td colspan="4" style="text-align: center; padding: 12px; border: 1px solid #000000;">No account entries available.</td>
  </tr>
  }
</table>

<div style="display: flex; margin-bottom: 10px; padding-left: 20px; padding-right: 35px; line-height: 24px;">
  <div style="margin: 0 0 0 auto;">
    <table cellpadding="0">
      <tr>
        <td style="text-align: right;"><b>TAXABLE AMOUNT</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{currencyCode}}
          {{taxableAmount | number: '1.2-2'}}</td>
      </tr>
      <tr>
        <td style="text-align: right;"><b>TAX</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{currencyCode}}
          {{taxAmount | number: '1.2-2'}}</td>
      </tr>
      <tr>
        <td style="text-align: right;"><b>NET TOTAL</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{currencyCode}}
          {{netTotal | number: '1.2-2'}}</td>
      </tr>
    </table>
  </div>
</div>
